// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.vacp-color-input-group {\n    display: none !important;\n}\n.vacp-copy-button {\n    display: none !important;\n}\n.expenses {\n    color: red\n}\n.incoming {\n    color: green\n}\n.radius-label {\n    border-radius: 90%;\n    width: 40px;\n    height: 40px;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
